import { render, staticRenderFns } from "./TxHistorySkeleton.vue?vue&type=template&id=2a494a2f"
import script from "./TxHistorySkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./TxHistorySkeleton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports